/**
 * Module Item Attachments — Zod schemas for lesson file attachments.
 *
 * Используется admin panel для прикрепления файлов к уроку и backend
 * API для валидации входящих запросов.
 */

import { z } from 'zod';

/**
 * Привязать уже загруженный файл к уроку.
 * fileId приходит с фронта после `POST /api/files/admin/upload`.
 */
export const AttachFileToModuleItemSchema = z.object({
  fileId: z.number().int().positive(),
});

export type AttachFileToModuleItemInput = z.infer<typeof AttachFileToModuleItemSchema>;

/**
 * Перестановка порядка вложений урока (drag&drop).
 * attachmentIds — массив ID в новом порядке; массив должен быть
 * полным: содержать ВСЕ вложения конкретного урока.
 */
export const ReorderModuleItemAttachmentsSchema = z.object({
  attachmentIds: z.array(z.number().int().positive()).min(1),
});

export type ReorderModuleItemAttachmentsInput = z.infer<
  typeof ReorderModuleItemAttachmentsSchema
>;

/**
 * DTO, возвращаемый эндпоинтами `GET /api/module-items/:id/attachments`
 * и `GET /api/courses/:slug/lessons/:lessonId` (для платформы).
 */
export interface ModuleItemAttachmentDto {
  id: number;
  fileId: number;
  name: string;
  mimeType: string;
  size: number;
  url: string;
  order: number;
  createdAt: string;
}
